import GridLayoutPreview from '@/components/GridLayoutPreview';
import Layout from '@/components/layout';
import Preview from '@/components/Preview';
import { stickyTop } from '@/constants';
import { PATH } from '@/constants/path';
import { deepObjectEqual } from '@/helpers';
import navigateSlice from '@/redux/slice/navigate';
import settingsSlice, { dataSettingsBackupSelector, dataSettingsSelector } from '@/redux/slice/settings.slice';
import { memo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { SettingsStyled } from './styled';

const LIST_PATH_IN_PREVIEW = [PATH.APPEARANCE.pathname];

const Settings = ({ children }: any) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const dataSettings = useSelector(dataSettingsSelector);
  const dataSettingsBackup = useSelector(dataSettingsBackupSelector);

  useEffect(() => {
    if (!deepObjectEqual(dataSettings, dataSettingsBackup)) {
      dispatch(settingsSlice.actions.handleDataSettings(dataSettingsBackup));
      dispatch(
        navigateSlice.actions.handleNavigate({
          pathname: undefined,
          search: undefined,
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout>
      <SettingsStyled>
        {LIST_PATH_IN_PREVIEW?.includes(location?.pathname) ? (
          <GridLayoutPreview>
            <div className="wrap-content d-flex flex-column gap-12">{children}</div>
            <Preview top={stickyTop} checkScheduling />
          </GridLayoutPreview>
        ) : (
          <>{children}</>
        )}
      </SettingsStyled>
    </Layout>
  );
};

export default memo(Settings);
